import React from 'react'

import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.snow.css'

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'image'],
    ['clean']
  ]
}

const textEditor = ({ changed, inputValue }) => {
  // state = { text: this.props.inputValue || 'Testing' } // You can also pass a Quill Delta here

  // handleChange = value => {
  //   this.props.changed(value)
  // }

  return <ReactQuill value={inputValue} onChange={content => changed(content)} modules={modules} />
}

export default textEditor
